import { SelectedFilter } from "../../../components/Filters/types";

export interface AuditLogRequestDto {
    entity: string
    action?: AuditActionEnum
    source?: string
    description?: string
    filters?: SelectedFilter[]
}

export interface AuditLogListItem {
    id: number;
    timestamp: string;
    userId?: number;
    userName?: string;
    entity: string;
    action: string;
    recordId?: string;
}

export enum AuditActionEnum
{
    Create,
    Update,
    Delete,
    Details,
    Historical,
    Dashboard,
    SendEmail,
    ProcessByAI,
    UpdateStatus,
    Print,
    Login,
    Logout,
    SendComment,
    ReplyEmail,
    ExportCsv
}

// Listado de Entidades añadidas a la Auditoria (Tiene que ser el nombre del controlador)
export enum AuditEntityEnum
{
    Claim = "Claim",
    Dashboard = "Dashboard",
    DashboardIndicator = "DashboardIndicator",
    Auth = "Auth"
}
